import cardsImage from 'app/common/images/bank-logos.png'

import styles from './BankPaymentTypesInformer.module.scss';

/**
 *  Список иконок поддерживаемых типов оплаты для подвала
 */

const BankPaymentTypesInformer = () => {
  return (
    <img src={cardsImage} className={styles.cards} alt="available payments" />
  )
}

export default BankPaymentTypesInformer
